import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { pidakatData } from '../../utils/pidakatData';
import './Pidakat.css';

const Pidakat = () => {
    const { language } = useLanguage();
    const data = pidakatData[language];

    return (
        <div className="pidakat-edu-page">
            <div className="pidakat-edu-hero">
                <div className="hero-overlay-edu"></div>
                <div className="hero-content-edu">
                    <div className="hero-text-edu">
                        <h1>{data.title}</h1>
                        <div className="title-divider-edu">
                            <span></span>
                            <i className="fas fa-dharmachakra"></i>
                            <span></span>
                        </div>
                        <p className="hero-subtitle-edu">{data.subtitle}</p>
                    </div>
                </div>
            </div>

            <div className="pidakat-edu-container">
                <div className="content-section-edu">
                    {data.description.map((paragraph, index) => (
                        <div key={index} className="content-card-edu">
                            <p>{paragraph}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Pidakat;